__turbopack_context__.v({
  "background_white": "Home-module__g21JLG__background_white",
  "card": "Home-module__g21JLG__card",
  "code": "Home-module__g21JLG__code",
  "container": "Home-module__g21JLG__container",
  "description": "Home-module__g21JLG__description",
  "footer": "Home-module__g21JLG__footer",
  "grid": "Home-module__g21JLG__grid",
  "image": "Home-module__g21JLG__image",
  "inputFileBtnHide": "Home-module__g21JLG__inputFileBtnHide",
  "logo": "Home-module__g21JLG__logo",
  "main": "Home-module__g21JLG__main",
  "main_for_men": "Home-module__g21JLG__main_for_men",
  "main_for_women": "Home-module__g21JLG__main_for_women",
  "main_loading": "Home-module__g21JLG__main_loading",
  "sign_up_main": "Home-module__g21JLG__sign_up_main",
  "title": "Home-module__g21JLG__title",
});
